import Actions from '../../odata/actions';

const actions = new Actions('skillItem', 'skillItems');

export default actions;
